<template>
  <Dialog v-model:open="isOpen">
    <DialogContent is-static-backdrop>
      <DialogHeader>
        <DialogTitle>Enable/Disable Sharing</DialogTitle>
      </DialogHeader>
      <div class="tw-px-6">
        <form class="form" role="form">
          <div class="form-group row">
            <label class="col-form-label col-sm-3 text-right">Shared</label>
            <div class="col-sm-8 pt-3">
              <groups-picker
                v-model="sharedGroups"
              />
            </div>
          </div>
        </form>
      </div>
      <DialogFooter>
        <DialogClose as-child>
          <button
            type="button"
            class="btn btn-default"
          >
            Close
          </button>
        </DialogClose>
        <button
          type="button"
          class="btn btn-primary"
          :disabled="isSubmitting"
          @click="confirmSharingForm"
        >
          Save
        </button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script>
import { ref } from 'vue'
import pick from 'lodash/pick'
import GroupsPicker from '../groups-picker.vue'
import useSharedGroups from '../../../hooks/use-shared-groups'
import { useTeamAssets } from './use-team-assets'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/shadcn/components/ui/dialog'

export default {
  name: 'TeamAssetSharingForm',
  components: {
    GroupsPicker,
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle
  },
  setup (props, { expose }) {
    const isSubmitting = ref(false)
    const isOpen = ref(false)
    const { sharedGroups, sharedGroupsForm } = useSharedGroups()
    const { updateTeamAsset } = useTeamAssets()

    const teamAsset = ref(null)

    const startSharing = (asset) => {
      teamAsset.value = asset
      sharedGroupsForm.value = pick(asset, ['shared', 'hash_shared_to_group_ids'])

      isOpen.value = true
    }

    const confirmSharingForm = async () => {
      if (!teamAsset.value) {
        return
      }

      try {
        isSubmitting.value = true

        await updateTeamAsset(teamAsset.value, sharedGroupsForm.value)

        isOpen.value = false
      } catch (e) {
        console.error(e)
      } finally {
        isSubmitting.value = false
      }
    }

    expose({
      startSharing
    })

    return {
      isSubmitting,
      sharedGroups,
      confirmSharingForm,
      isOpen
    }
  }
}
</script>
